import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import _ from "lodash";
import { StyledLabel } from "../../../components/styles";
import { ButtonContainer } from "./../styles";
import {
    SeparateLine,
    ButtonRow,
    Tags,
    PageTitle,
    ProjectInfo,
    WorkingConditionSteps,
    DataView,
    TagsContainer,
    StyledAction,
    ActionsContainer,
    DeactivateReasonContainer,
    ObjectionContainer,
    ProjectFinancialLegalContainer,
    ConditionSteps,
    ProjectCondition,
} from "../../../styles/elements/main";
import {
    FormGroup,
    FormRow,
    FormGroupTextEditor,
    RowFormGroupContainer,
    HintMessageContent,
} from "../../../styles/forms/main";
import {
    deleteAllAttachments,
    deleteSingleAttachment,
    getConditionById,
    getObjectionById,
    getStandardsAndProceduresList,
    updateProjectInfo,
    uploadProjectInfoAttachments,
} from "../api";
import { mapConditionToUi, mapObjectionsToUi, mapOptionsToUi } from "./../mapToUi";
import Button from "./../../../components/button";
import { submitSupplyChainForm } from "./../api";
import { setMessage } from "./../../shared/notification/slice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DeactivateModal from "./deactivateModal";
import Action from "../../../components/dropdownAction";
import { userRoles } from "./../../../constants/userRoles";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DeclineModal from "./declineModal";
import ObjectionModal from "./objectionsModal";
import AccordionComponent from "./../../../components/accordion";
import ObjectionsView from "./objectionsView";
import TabList from "./../../../components/tabList";
import styled from "styled-components";
import trackAnalytics from "./../../../trackAnalytics";
import QADetails from "./QADetails";
import moment from "moment";
import ProjectFinancialLegalForm from "./ProjectFinancialLegal";
import { convertFileToBase64 } from "../../../utils/getBase64";
import { showLoader } from "../../shared/FullPageLoader/slice";
import { mapUpdateSupplyChainProjectInfoToData } from "../mapToData";
import ModalComponent from "../../../components/modal";
import Spinner from "../../../components/Spinner";
import TextArea from "../../../components/textArea";
import { getUserRoles } from "../../auth/slice";
import { compareObjects } from "../../../hooks/compareObjects";
import { mapUpdateProjectInfoToMixPanel } from "../mapDataToMixpanel";
import ExtraOperationalRequirements from "./ExtraOperationalRequirements";
import { getDuration } from "utils/dateAndTime";

export const ObjectionsContainer = styled.div`
    padding-bottom: 4rem;
`;
export default function SupplyChainProjectProfile({
    projectId,
    clientProject,
    organizationId,
    penaltiesAndDeductions,
    setPenaltiesAndDeductions,
    setAllIllaDeductions,
    setAllClientDeductions,
    allIllaDeductions,
    allClientDeductions,
}) {
    const [activeWorkingCondition, setActiveWorkingCondition] = useState(0);
    const [ConditionData, setConditionData] = useState([]);
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [showObjectionModal, setShowObjectionModal] = useState(false);
    const [conditionId, setConditionId] = useState("");
    const [objection, setObjection] = useState({});
    const dispatch = useDispatch();
    const history = useHistory();
    const [activeObjection, setActiveObjection] = useState("");
    const [SubmitObjectSuccess, setSubmitObjectSuccess] = useState(false);
    const [isProjectInfoEditable, setIsProjectInfoEditable] = useState(false);
    const [showDiscardEditModal, setShowDiscardModal] = useState(false);
    // QA details sections
    const [qaDetails, setQaDetails] = useState({});
    const [operationalAttachments, setOperationalAttachments] = useState([]);
    const [standardsAndProceduresList, setStandardsAndProceduresList] = useState([]);
    // Project Financial section
    const [projectFinancialLegal, setProjectFinancialLegal] = useState({});
    const [salesAttachments, setSalesAttachments] = useState([]);
    const [supplierAttachments, setSupplierAttachments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const getCurrentUserRoles = useSelector(getUserRoles());
    const [openTime, setOpenTime] = useState(null);

    const fetchStandardsAndProcedures = async () => {
        const data = await getStandardsAndProceduresList();
        setStandardsAndProceduresList(
            mapOptionsToUi(
                _.values(data?.entities["standardsAndOperationalProcedures"]),
                "id",
                "description"
            )
        );
    };

    useEffect(() => {
        const timeNow = new Date();
        setOpenTime(timeNow);
    }, []);

    useEffect(() => {
        setQaDetails(clientProject?.qaDetails);
        setPenaltiesAndDeductions(clientProject?.deductionsValues);
    }, [clientProject]);

    useEffect(() => {
        setProjectFinancialLegal(clientProject?.projectFinancialLegal);
    }, [clientProject]);

    useEffect(() => {
        SubmitObjectSuccess && getObjection(activeObjection);
        setSubmitObjectSuccess(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SubmitObjectSuccess]);

    useEffect(() => {
        if (clientProject?.salesConditionsId?.length > 0) {
            FetchProjectProfileCondition(clientProject?.salesConditionsId[0]);
            setConditionId(clientProject?.salesConditionsId[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientProject]);

    useEffect(() => {
        if (ConditionData && ConditionData?.objectionsId?.length > 0)
            getObjection(ConditionData?.objectionsId[0]?.id);
    }, [ConditionData]);

    const FetchProjectProfileCondition = async (conditionId) => {
        const data = await getConditionById(conditionId);
        setConditionData(
            mapConditionToUi(
                _.values(data?.entities["monthlyProjectTruckTypeConditions"]),
                _.values(data?.entities["truckTypes"]),
                _.values(data?.entities["branches"]),
                _.values(data?.entities["suppliers"]),
                _.values(data?.entities["objections"])
            )
        );
        if (_.values(data?.entities["objections"]).length > 0) {
            const objectLength = Object.keys(_.values(data?.entities["objections"])).length;
            getObjection(_.values(data?.entities["objections"])[objectLength - 1]?.id);
            setActiveObjection(_.values(data?.entities["objections"])[objectLength - 1]?.id);
        }
    };

    const handleEditProjectInfo = () => {
        trackAnalytics("Edit Project info clicks");
        setIsProjectInfoEditable(true);
    };

    const handleSubmitProjectInfo = () => {
        setIsLoading(true);
        updateAttachments();
    };

    const updateAttachments = async () => {
        if (
            salesAttachments.length > 0 ||
            operationalAttachments.length > 0 ||
            supplierAttachments.length > 0
        ) {
            let allAttachments = [
                { type: "sales_contract", files: salesAttachments },
                { type: "operational", files: operationalAttachments },
                { type: "supply_contract", files: supplierAttachments },
            ];
            for (let attachment of allAttachments) {
                await Promise.all(
                    attachment.files.map(async (document) => {
                        try {
                            let file = await convertFileToBase64(document);
                            const data = {
                                data: {
                                    type: "attachments",
                                    attributes: {
                                        attachedItemId: projectId,
                                        attachedItemType: "Project",
                                        documentType: attachment.type,
                                        document: file,
                                    },
                                },
                            };
                            const response = await uploadProjectInfoAttachments(data);
                            const attachments = _.values(response?.entities["attachments"]);
                            const extractedAttachments = attachments.map((attachment) => {
                                const { documentType, document } = attachment?.attributes;
                                const url = document && document.url ? document.url : null;
                                return { documentType, url };
                            });

                            trackAnalytics(
                                `${getCurrentUserRoles}_project_info_save_edit`,
                                ...extractedAttachments
                            );
                        } catch (err) {
                            dispatch(
                                setMessage({
                                    content: err,
                                    title: `Couldn't update project profile attachments  `,
                                    isError: true,
                                })
                            );
                        }
                    })
                );
            }
            updateProject();
        } else {
            updateProject();
        }
    };

    // * updateProject() for sending updates to the server and adding mixpanel
    const updateProject = () => {
        const data = {
            qaDetails,
            projectFinancialLegal,
        };
        const changedProps = compareObjects(clientProject, { ...clientProject, ...data });
        const formData = mapUpdateSupplyChainProjectInfoToData(projectId, data);
        const mixPanelData = mapUpdateProjectInfoToMixPanel(
            changedProps,
            projectId,
            clientProject?.status
        );
        updateProjectInfo(projectId, formData)
            .then((res) => {
                setIsLoading(false);
                trackAnalytics(`Save project info edits submissions`, mixPanelData);
                dispatch(
                    setMessage({
                        content: `project profile condition updated successfully `,
                        isError: false,
                    })
                );
                history.push({
                    pathname: `/clientProjects/${projectId}`,
                    state: { clientId: organizationId, entityName: "projects" },
                });
                dispatch(showLoader());
                window.location.reload(false);
            })
            .catch((err) => {
                setIsLoading(false);
                dispatch(
                    setMessage({
                        content: err,
                        title: `Couldn't update project profile info  `,
                        isError: true,
                    })
                );
            });
    };

    const handleDeleteUploadedItem = (id) => {
        deleteSingleAttachment(id)
            .then(() => {
                dispatch(
                    setMessage({
                        content: `Attachment deleted successfully`,
                        isError: false,
                    })
                );
                history.push({
                    pathname: `/clientProjects/${projectId}`,
                    state: { clientId: organizationId, entityName: "projects" },
                });
                dispatch(showLoader());
                window.location.reload(false);
            })
            .catch((err) => {
                dispatch(
                    setMessage({
                        content: err,
                        title: `Couldn't delete attachments`,
                        isError: true,
                    })
                );
            });
    };

    const handleDeleteAllAttachements = () => {
        deleteAllAttachments()
            .then((res) => {
                dispatch(
                    setMessage({
                        content: `Attachments deleted successfully`,
                        isError: false,
                    })
                );
                history.push({
                    pathname: `/clientProjects/${projectId}`,
                    state: { clientId: organizationId, entityName: "projects" },
                });
                dispatch(showLoader());
                window.location.reload(false);
            })
            .catch((err) => {
                dispatch(
                    setMessage({
                        content: err,
                        title: `Couldn't delete attachments`,
                        isError: true,
                    })
                );
            });
    };

    const handleDecline = () => {
        trackAnalytics(`${getCurrentUserRoles}_project_decline`, {
            "Time to decline": getDuration(openTime, new Date()),
        });
        setShowDeclineModal(true);
    };
    const handleObject = (e) => {
        setShowObjectionModal(true);
        trackAnalytics(`${getCurrentUserRoles}_project_object`, {
            "Time to object": getDuration(openTime, new Date()),
        });
    };
    const handleEvent = () => {
        trackAnalytics("Approve project profile submissions", {
            "Time to approve": getDuration(openTime, new Date()),
        });
        submitSupplyChainForm(conditionId, "approve")
            .then(async (res) => {
                const response = await res;
                const id = _.values(response.entities["monthlyProjectTruckTypeConditions"])[0][
                    "attributes"
                ].monthlyProjectId;

                dispatch(
                    setMessage({
                        content: `project event updated successfully `,
                        isError: false,
                    })
                );
                history.push({
                    pathname: `/clientProjects/${id}`,
                    state: { projectId: id, clientId: organizationId, entityName: "projects" },
                });
                window.location.reload(false);
            })
            .catch((error) => {
                dispatch(
                    setMessage({
                        content: error,
                        title: `Couldn't update  project profile  `,
                        isError: true,
                    })
                );
            });
    };
    const handleOnClick = (item) => {
        getObjection(item?.id);
        setActiveObjection(item?.id);
    };
    const objectionBody = () => (
        <ObjectionContainer>
            <TabList
                list={ConditionData?.objectionsId}
                handleOnClick={handleOnClick}
            />
            <ObjectionsView
                objection={objection}
                activeObjectionId={activeObjection}
                projectId={projectId}
                submitObjectionSuccessfully={(value) => setSubmitObjectSuccess(value)}
            />
        </ObjectionContainer>
    );
    const getObjection = async (objectionId) => {
        const data = await getObjectionById(objectionId);
        setObjection(
            mapObjectionsToUi(
                _.values(data?.entities["creators"]),
                _.values(data?.entities["mentionedAdminUsers"]),
                _.values(data?.entities["adminUsers"]),
                _.values(data?.entities["items"]),
                _.values(data?.entities["sections"]),
                _.values(data?.entities["comments"]),
                _.values(data?.entities["objections"])
            )
        );
    };
    return (
        <>
            <ObjectionsContainer>
                <ProjectInfo>
                    <PageTitle>
                        <FormattedMessage id="client.project-create-header" /> #{projectId}
                        <TagsContainer>
                            <Tags>{clientProject?.status}</Tags>
                        </TagsContainer>
                    </PageTitle>
                    {!isProjectInfoEditable && (
                        <StyledAction>
                            <Action
                                options={[
                                    {
                                        name: "edit",
                                        eventHandler: () => handleEditProjectInfo(),
                                        disable: false,
                                    },
                                ]}
                                icon="<MoreVertIcon/>"
                            />
                        </StyledAction>
                    )}
                    <FormRow>
                        <FormGroup>
                            <StyledLabel>Client Name</StyledLabel>
                            <DataView>{clientProject?.clientName}</DataView>
                        </FormGroup>
                        <FormGroup>
                            <StyledLabel>Project Name</StyledLabel>
                            <DataView>{clientProject?.name}</DataView>
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <StyledLabel>Project Type</StyledLabel>
                            <DataView>{clientProject?.projectType}</DataView>
                        </FormGroup>
                        <FormGroup>
                            <StyledLabel>Requested Date </StyledLabel>
                            <DataView>{clientProject?.requestedAt}</DataView>
                        </FormGroup>
                    </FormRow>
                    <ProjectFinancialLegalContainer>
                        <ProjectFinancialLegalForm
                            projectFinancialLegal={projectFinancialLegal}
                            isEditable={isProjectInfoEditable}
                            userRole="project_manager"
                            setFinancialLegal={(fieldName, value) => {
                                setProjectFinancialLegal({
                                    ...projectFinancialLegal,
                                    [fieldName]: value,
                                });
                            }}
                            setSalesAttachments={setSalesAttachments}
                            setSupplierAttachments={setSupplierAttachments}
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            onDeleteAllAttachements={handleDeleteAllAttachements}
                            setAllIllaDeductions={setAllIllaDeductions}
                            setAllClientDeductions={setAllClientDeductions}
                            allIllaDeductions={allIllaDeductions}
                            allClientDeductions={allClientDeductions}
                            deductionsValues={penaltiesAndDeductions}
                            setDeductionsValues={setPenaltiesAndDeductions}
                        />
                    </ProjectFinancialLegalContainer>
                    <div>
                        <QADetails
                            isEditable={isProjectInfoEditable}
                            attachements={clientProject?.qaDetails?.attachments}
                            // User can edit any of the following attributes
                            qADetails={qaDetails}
                            setQaDetails={(fieldName, value) => {
                                setQaDetails({
                                    ...qaDetails,
                                    [fieldName]: value,
                                });
                            }}
                            setOperationalAttachments={setOperationalAttachments}
                            userRole="project_manager"
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            onDeleteAllAttachements={handleDeleteAllAttachements}
                            standardsAndProceduresList={standardsAndProceduresList}
                        />
                        <SeparateLine />
                    </div>
                    {isProjectInfoEditable && (
                        <ButtonRow>
                            <Button
                                type="button"
                                name="Cancel"
                                btnStyle="secondBtn"
                                onChange={() => setShowDiscardModal(true)}
                            />
                            <Button
                                type="button"
                                name={isLoading ? <Spinner /> : "Save"}
                                btnStyle="primaryBtn"
                                onChange={handleSubmitProjectInfo}
                            />
                        </ButtonRow>
                    )}
                    <ModalComponent
                        header="Discard edits"
                        open={showDiscardEditModal}
                        onClose={() => {
                            setShowDiscardModal(false);
                        }}
                        submitBtnText="Discard"
                        onSubmit={() => {
                            trackAnalytics(`${getCurrentUserRoles}_project_cancel_editing`);
                            setProjectFinancialLegal(clientProject?.projectFinancialLegal);
                            setQaDetails(clientProject?.qaDetails);
                            setShowDiscardModal(false);
                            setIsProjectInfoEditable(false);
                        }}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        If you discard it now, you'll lose all the edits you've made
                    </ModalComponent>
                </ProjectInfo>
                <div>
                    <WorkingConditionSteps>
                        {clientProject?.salesConditionsId?.map((item, index) => (
                            <ConditionSteps
                                className={index === activeWorkingCondition ? "active" : ""}
                                onClick={() => {
                                    setConditionId(item);
                                    setActiveWorkingCondition(index);
                                    FetchProjectProfileCondition(item);
                                    ConditionData?.objectionsId?.length > 0 &&
                                        getObjection(ConditionData?.objectionsId[0]?.id);
                                }}
                            >
                                Working condition {index + 1}
                            </ConditionSteps>
                        ))}
                    </WorkingConditionSteps>
                    <ProjectCondition>
                        <div>
                            <ActionsContainer>
                                {ConditionData?.status && <Tags>{ConditionData?.status}</Tags>}
                                {ConditionData?.salesData?.deactivationReason === null &&
                                    ConditionData?.status?.toLowerCase() !== "declined" &&
                                    ConditionData?.status?.toLowerCase() !== "deactivated" && (
                                        <StyledAction>
                                            <Action
                                                options={[
                                                    {
                                                        name: "deactivate",
                                                        eventHandler: () => {
                                                            setShowDeactivateModal(true);
                                                        },
                                                        disable: false,
                                                    },
                                                ]}
                                                icon="<MoreVertIcon/>"
                                            />
                                        </StyledAction>
                                    )}
                            </ActionsContainer>
                            {ConditionData?.salesData?.deactivationReason !== null &&
                                ConditionData?.status?.toLowerCase() === "deactivated" && (
                                    <DeactivateReasonContainer>
                                        <WarningAmberIcon />
                                        <HintMessageContent>
                                            <h3>This Condition Deactivated</h3>
                                            <p>{ConditionData?.salesData?.deactivationReason}</p>
                                        </HintMessageContent>
                                    </DeactivateReasonContainer>
                                )}
                            {ConditionData.declinationDetails !== null &&
                                ConditionData?.status?.toLowerCase() === "declined" && (
                                    <DeactivateReasonContainer>
                                        <WarningAmberIcon />
                                        <HintMessageContent>
                                            <h3>This Condition has been declined</h3>
                                            {ConditionData?.declinationDetails?.salesPricing !==
                                                null && (
                                                <div className="decline-item">
                                                    <label>- sales Pricing</label>
                                                    <p>
                                                        {
                                                            ConditionData?.declinationDetails
                                                                ?.salesPricing
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                            {ConditionData?.declinationDetails?.supplierPricing !==
                                                null && (
                                                <div className="decline-item">
                                                    <label>- supply Pricing</label>
                                                    <p>
                                                        {
                                                            ConditionData?.declinationDetails
                                                                ?.supplierPricing
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                            {ConditionData?.declinationDetails?.supplierFulfillment !==
                                                null && (
                                                <div className="decline-item">
                                                    <label>- supply Fulfilment</label>
                                                    <p>
                                                        {
                                                            ConditionData?.declinationDetails
                                                                ?.supplierFulfillment
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                            {ConditionData?.declinationDetails
                                                ?.clientRequirements !== null && (
                                                <div className="decline-item">
                                                    <label>- client Requirement</label>
                                                    <p>
                                                        {
                                                            ConditionData?.declinationDetails
                                                                ?.clientRequirements
                                                        }
                                                    </p>
                                                </div>
                                            )}
                                        </HintMessageContent>
                                    </DeactivateReasonContainer>
                                )}
                            <h3>Truck Details</h3>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Truck Type</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.truckTypeName}</DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Number of Trucks</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.numberOfTrucks}</DataView>
                                </FormGroup>
                            </FormRow>
                            {ConditionData?.salesData?.hasPreferredModelYear && (
                                <FormRow>
                                    <FormGroup>
                                        <StyledLabel>Required model year starts from</StyledLabel>
                                        <DataView>
                                            {ConditionData?.salesData?.requiredModelYearStartsFrom}
                                        </DataView>
                                    </FormGroup>
                                </FormRow>
                            )}
                        </div>
                        <SeparateLine />
                        <ExtraOperationalRequirements
                            isEditable={false}
                            workingCondition={ConditionData?.salesData}
                        />
                        <div>
                            <h3>Client Operational Details</h3>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Kick-off Date</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.kickoffDate}</DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>End Date</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.endDate}</DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Operational Model</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.salesChannels &&
                                            Array.from(
                                                ConditionData?.salesData?.salesChannels
                                            )?.map((model) => <span>{model.value}</span>)}
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Working Area</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.serviceAreas &&
                                            Array.from(ConditionData?.salesData?.serviceAreas)?.map(
                                                (area) => <span>{area.value}</span>
                                            )}
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Pickup Location</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.pickUpLocation}</DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Pickup Arrival Time</StyledLabel>
                                    <DataView>
                                        {moment(ConditionData?.salesData?.pickUpTime).format("LT")}
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Number of Working Days per Month</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.workingDaysPerMonth}
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Weekly Off Days</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.weeklyOffDays.map((day) => (
                                            <span>{day.value}</span>
                                        ))}
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel> Working Hours per Day</StyledLabel>
                                    <DataView>
                                        {ConditionData?.salesData?.workingHoursPerDay}
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Mileage</StyledLabel>
                                    <DataView>{ConditionData?.salesData?.kiloMeters}</DataView>
                                </FormGroup>
                            </FormRow>
                            {ConditionData?.salesData?.operationalSpecialDetails && (
                                <FormRow>
                                    <FormGroupTextEditor>
                                        <StyledLabel>
                                            {" "}
                                            Special Requirements for Operational
                                        </StyledLabel>
                                        <DataView>
                                            {ConditionData?.salesData?.operationalSpecialDetails}
                                        </DataView>
                                    </FormGroupTextEditor>
                                </FormRow>
                            )}
                        </div>
                        <SeparateLine />
                        <div>
                            <h3>Supply Fulfillment Details </h3>
                            {ConditionData?.supplyData?.fullFillmentDetails?.suppliers.map(
                                (supplier) => (
                                    <>
                                        <FormRow>
                                            <FormGroup>
                                                <StyledLabel>Suppliers</StyledLabel>
                                                <DataView>{supplier?.supplier}</DataView>
                                            </FormGroup>
                                            <FormGroup>
                                                <StyledLabel>Number of Trucks</StyledLabel>
                                                <DataView>{supplier?.numberOfTrucks}</DataView>
                                            </FormGroup>
                                        </FormRow>
                                        {supplier?.assignedTrucks.length > 0 &&
                                            supplier?.assignedTrucks.map((truck, index) => (
                                                <FormRow>
                                                    <RowFormGroupContainer>
                                                        <FormGroup>
                                                            <StyledLabel>
                                                                {`Truck ${index + 1}`}
                                                            </StyledLabel>
                                                            <DataView>{truck.truck}</DataView>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <StyledLabel>
                                                                {`Driver ${index + 1}`}
                                                            </StyledLabel>
                                                            <DataView>{truck.driver}</DataView>
                                                        </FormGroup>
                                                    </RowFormGroupContainer>
                                                </FormRow>
                                            ))}
                                        <FormRow>
                                            <FormGroup>
                                                <StyledLabel>Working Hours per Day</StyledLabel>
                                                <DataView>{supplier?.workingHoursPerDay}</DataView>
                                            </FormGroup>
                                            <FormGroup>
                                                <StyledLabel>Mileage</StyledLabel>
                                                <DataView>{supplier?.kiloMeters}</DataView>
                                            </FormGroup>
                                        </FormRow>
                                    </>
                                )
                            )}
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Number of Helpers</StyledLabel>
                                    <DataView>
                                        {
                                            ConditionData?.supplyData?.fullFillmentDetails
                                                ?.numberOfHelpers
                                        }
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Number of delivery Delegates</StyledLabel>
                                    <DataView>
                                        {
                                            ConditionData?.supplyData?.fullFillmentDetails
                                                ?.deliveryDelegate
                                        }
                                    </DataView>
                                </FormGroup>
                            </FormRow>

                            {ConditionData?.supplyData?.supplierOtherDetails && (
                                <FormRow>
                                    <FormGroupTextEditor>
                                        <StyledLabel>Supplier Other Details </StyledLabel>
                                        <DataView>
                                            {ConditionData?.supplyData?.supplierOtherDetails}
                                        </DataView>
                                    </FormGroupTextEditor>
                                </FormRow>
                            )}
                        </div>
                        <SeparateLine />
                        <div>
                            <h3>Pricing Details</h3>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Truck price per month*</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.truckPricePerMonth
                                                ) >
                                                Number(ConditionData?.salesData?.truckPricePerMonth)
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales: </h4>
                                            {ConditionData?.salesData?.truckPricePerMonth}
                                        </span>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.truckPricePerMonth
                                                ) >
                                                Number(ConditionData?.salesData?.truckPricePerMonth)
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>
                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.truckPricePerMonth
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Fuel & Oil Price per Kilometer</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.GazPricePerkiloMeter
                                                ) >
                                                Number(
                                                    ConditionData?.salesData
                                                        ?.gasAndOilPerUnitDistance
                                                )
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>{" "}
                                            {ConditionData?.salesData?.gasAndOilPerUnitDistance}
                                        </span>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.GazPricePerkiloMeter
                                                ) >
                                                Number(
                                                    ConditionData?.salesData
                                                        ?.gasAndOilPerUnitDistance
                                                )
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>

                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.GazPricePerkiloMeter
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Extra Working Hour Price</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.extraHourPrice
                                                ) > Number(ConditionData?.salesData?.extraHourPrice)
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>{" "}
                                            {ConditionData?.salesData?.extraHourPrice}
                                        </span>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.extraHourPrice
                                                ) > Number(ConditionData?.salesData?.extraHourPrice)
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>

                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraHourPrice
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Extra Kilometer Price*</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.extraUnitDistancePrice
                                                ) >
                                                Number(
                                                    ConditionData?.salesData?.extraUnitDistancePrice
                                                )
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>
                                            {ConditionData?.salesData?.extraUnitDistancePrice}
                                        </span>
                                        <span
                                            className={
                                                Number(
                                                    ConditionData?.supplyData?.pricingDetails
                                                        ?.extraUnitDistancePrice
                                                ) >
                                                Number(
                                                    ConditionData?.salesData?.extraUnitDistancePrice
                                                )
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>
                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraUnitDistancePrice
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            <FormRow>
                                <FormGroup>
                                    <StyledLabel>Over Night Stay Price</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.overnightPrice >
                                                ConditionData?.salesData?.overnightPrice
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>{" "}
                                            {ConditionData?.salesData?.overnightPrice} %
                                        </span>
                                        <span
                                            className={
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.overnightPrice >
                                                ConditionData?.salesData?.overnightPrice
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>
                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.overnightPrice
                                            }{" "}
                                            %
                                        </span>
                                    </DataView>
                                </FormGroup>
                                <FormGroup>
                                    <StyledLabel>Extra Day Price*</StyledLabel>
                                    <DataView>
                                        <span
                                            className={
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraDayPrice >
                                                ConditionData?.salesData?.extraDayPrice
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>sales:</h4>{" "}
                                            {ConditionData?.salesData?.extraDayPrice}
                                        </span>
                                        <span
                                            className={
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraDayPrice >
                                                ConditionData?.salesData?.extraDayPrice
                                                    ? "error"
                                                    : ""
                                            }
                                        >
                                            <h4>supply:</h4>
                                            {
                                                ConditionData?.supplyData?.pricingDetails
                                                    ?.extraDayPrice
                                            }
                                        </span>
                                    </DataView>
                                </FormGroup>
                            </FormRow>
                            {ConditionData?.status?.toLowerCase() !== "deactivated" && (
                                <ButtonRow>
                                    <ButtonContainer>
                                        {ConditionData?.status?.toLowerCase() !== "declined" &&
                                            ConditionData?.status?.toLowerCase() !== "approved" && (
                                                <Button
                                                    type="Decline"
                                                    name="Decline"
                                                    onChange={handleDecline}
                                                    btnStyle="secondBtn"
                                                />
                                            )}
                                        {ConditionData?.status?.toLowerCase() !== "approved" && (
                                            <Button
                                                type="Approve"
                                                name="Approve"
                                                onChange={handleEvent}
                                                btnStyle="primaryBtn"
                                            />
                                        )}
                                        <Button
                                            type="object"
                                            name="object"
                                            onChange={handleObject}
                                            btnStyle="primaryBtn"
                                        />
                                    </ButtonContainer>
                                </ButtonRow>
                            )}
                        </div>
                    </ProjectCondition>
                </div>
            </ObjectionsContainer>
            {ConditionData && ConditionData?.objectionsId?.length > 0 && (
                <div>
                    <AccordionComponent
                        id="Objection"
                        title="objections"
                        body={objectionBody()}
                        defaultExpanded
                    />
                </div>
            )}

            <DeactivateModal
                isShow={showDeactivateModal}
                activeWorkingCondition={activeWorkingCondition}
                conditionId={conditionId}
                onHide={() => {
                    setShowDeactivateModal(false);
                }}
                role={userRoles.PROJECT_MANAGER}
                status={ConditionData?.status}
            />
            <DeclineModal
                isShow={showDeclineModal}
                activeWorkingCondition={activeWorkingCondition}
                conditionId={conditionId}
                onHide={() => {
                    setShowDeclineModal(false);
                }}
                conditionStatus={clientProject?.status}
                projectStatus={clientProject?.status}
            />
            <ObjectionModal
                isShow={showObjectionModal}
                conditionStatus={clientProject?.status}
                activeWorkingCondition={activeWorkingCondition}
                conditionId={conditionId}
                onHide={() => {
                    setShowObjectionModal(false);
                }}
            />
        </>
    );
}
